export default __webpack_public_path__ + "static/media/materialui.d7f5c38f.svg";